import {
	AppState,
	HeaderState,
	IABState,
	MenuState
}														from '../';
import { Injectable }       from '@angular/core';
import { BehaviorSubject }  from 'rxjs';
import { UtilityService }   from './utility.service';

@Injectable()
export class StateService {
	mobile    = navigator.userAgent.indexOf('Phone')    !== -1 || (
              navigator.userAgent.indexOf('Android')  !== -1 &&
              navigator.userAgent.indexOf('Mobi')     !== -1);

	public app			= new BehaviorSubject(new AppState());
	public header:	BehaviorSubject<HeaderState>;
	public iab			= new BehaviorSubject(new IABState());
	public menu:    BehaviorSubject<MenuState>;

	set state(state: string) { this.setState(state, {}); };

	constructor(private utilityService: UtilityService) {
		this.header = new BehaviorSubject(new HeaderState(this));
		this.menu   = new BehaviorSubject(new MenuState(this));

    console.log('State service created');
	}

	isSubPageState(state): boolean {
		return ['about', 'iab', 'login', 'more', 'support', 'terms'].indexOf(state) > -1;
	}

  openUrl(url: string, label?: string) {
    if (label) {
      this.setState('iab', { url: url, label: label });
    } else {
      this.utilityService.openUrl(url);
    }
  }

	setState(state: string, data: any) {
		this.app.next(this.app.value.update(state));
		this.header.next(this.header.value.update(state, data));
		this.iab.next(this.iab.value.update(data));
		this.menu.next(this.menu.value.update(state));
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/state.service.ts